var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChautauquaArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.530483,
    height: 56.412663,
    viewBox: "0 0 8.871607 14.92585",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2.1440333,0 C -0.44901672,1.83594 -0.37666672,3.96777 0.93419328,5.3749 L 2.9577233,7.42384 0.88681328,9.49359 c -1.48,1.79814 -1.14532,3.47084 1.28932002,5.43226 l 5.92753,-5.82502 c 1.02181,-1.17674 1.05493,-2.05855 -0.0877,-3.26597 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChautauquaArrow);
export default __webpack_public_path__ + "static/media/chautauqua-arrow.d4415fa99965aecef9a5f21782c553e3.svg";
export { ForwardRef as ReactComponent };